export default "__VITE_ASSET__l4yue4y9__"